module.exports = __webpack_public_path__ + "img/electronic_engine_tune_up.53e5ddb3.svg";